export default __webpack_public_path__ + "static/media/mexico.bd630f9e.PNG";